import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-unlock-vessel-dialog',
    templateUrl: './unlock-vessel-dialog.component.html',
    styleUrls: ['./unlock-vessel-dialog.component.css'],
    standalone: false,
})
export class UnlockVesselDialogComponent {
    constructor(private dialogRef: MatDialogRef<UnlockVesselDialogComponent>) {}

    cancel() {
        this.dialogRef.close();
    }

    acceptUnlock() {
        this.dialogRef.close(true);
    }
}
